/**
 * Palette réservée à l'espace marchand : elle ne remplace pas la palette bleue publique.
 * Les valeurs CSS avec repli permettent aux composants partagés de conserver leur bleu
 * lorsqu'ils sont affichés hors d'un conteneur « private-ui ».
 */
export const PRIVATE_COLORS = {
  ink: '#151519',
  hover: '#34343c',
  accent: '#cef34a',
  soft: '#f0f8d6',
  border: '#dfe8c4',
  canvas: '#efeef3',
};

/** Accent de texte ou de bordure : noir dans l'espace privé, bleu dans le contexte public. */
export const PRIVATE_PRIMARY_COLOR = 'var(--private-ink, #2563eb)';
/** Surface de mise en avant : citron pâle dans l'espace privé, bleu pâle ailleurs. */
export const PRIVATE_PRIMARY_BACKGROUND = 'var(--private-soft, #eff6ff)';

/**
 * Tokens Ant Design du client privé : actions noires, sélection citron pâle et texte sombre.
 * Les couleurs de succès, d'erreur, d'avertissement et les palettes des graphiques
 * ne sont pas redéfinies, car elles portent une information métier.
 */
export const PRIVATE_THEME = {
  token: {
    colorPrimary: PRIVATE_COLORS.ink,
    colorPrimaryHover: PRIVATE_COLORS.hover,
    colorPrimaryActive: PRIVATE_COLORS.ink,
    colorPrimaryBg: PRIVATE_COLORS.soft,
    colorPrimaryBgHover: '#e6f4bb',
    colorPrimaryBorder: PRIVATE_COLORS.border,
    colorPrimaryBorderHover: PRIVATE_COLORS.ink,
    colorPrimaryText: PRIVATE_COLORS.ink,
    colorPrimaryTextHover: PRIVATE_COLORS.hover,
    colorPrimaryTextActive: PRIVATE_COLORS.ink,
    colorLink: PRIVATE_COLORS.ink,
    colorLinkHover: PRIVATE_COLORS.hover,
    colorLinkActive: PRIVATE_COLORS.ink,
    controlOutline: 'rgba(21, 21, 25, 0.15)',
  },
  components: {
    Button: { primaryShadow: 'none' },
    Table: { rowSelectedBg: PRIVATE_COLORS.soft, rowSelectedHoverBg: '#e6f4bb' },
    Select: { optionSelectedBg: PRIVATE_COLORS.soft },
    Segmented: { itemSelectedBg: PRIVATE_COLORS.ink, itemSelectedColor: '#ffffff' },
  },
};
